import { Typography } from "@mui/material";

import { howItWorksData } from "@/utils/staticData/howItWorks";
import FleetInquiryStepper from "./FleetInquiryStepper";
import Section from "@/components/Section";

const HowItWorks = () => {
  return (
    <Section
      pt={{ xs: 2.5, md: 8, lg: 12.5 }}
      pb={{ xs: 7.5, md: 8, lg: 12.5 }}
    >
      <Typography
        variant="h2"
        mb={{ xs: 2, md: 3 }}
        textAlign="center"
        maxWidth={610}
        mx="auto"
      >
        Discover How It Works. Simple, Fast, Effective.
      </Typography>
      <FleetInquiryStepper steps={howItWorksData} />
    </Section>
  );
};

export default HowItWorks;
